import { Link } from "react-router-dom";
import { C } from "@/brand/tokens";
import { pillars6 } from "@/brand/contentF6";
import { Box6 } from "@/components/common/Box6";
import { Eyebrow6 } from "@/components/common/Eyebrow6";
import { TextLink6 } from "@/components/common/TextLink6";
import { FocusAreas6 } from "./FocusAreas6";

/**
 * ServicesSection6 — four pillars in a boxed 2×2 grid.
 * Card pattern: name → one-sentence outcome → "Focus areas" keyword list →
 * "Explore [Service]" text link.
 */
export function ServicesSection6() {
  return (
    <section id="services" data-testid="services-6" style={{ background: C.surfaceLight2, color: C.textOnLight }}>
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <Eyebrow6 className="mb-6">Services</Eyebrow6>
            <h2
              className="font-cormorant"
              style={{
                color: C.textOnLight,
                fontSize: "clamp(2rem, 3.6vw, 3rem)",
                fontWeight: 400,
                lineHeight: 1.06,
                letterSpacing: "-0.012em",
                maxWidth: "22ch",
              }}
            >
              Four ways the firm shows up.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:pt-3">
            <p className="font-inter leading-[1.7] max-w-[46ch]" style={{ color: C.inkOnLight, fontSize: "1rem" }}>
              Every engagement is scoped in writing, held in confidence, and led
              with senior judgment. Scan the focus areas to find your situation,
              then explore the service.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-testid="services-grid-6">
          {pillars6.map((p, i) => (
            <Box6
              as={Link}
              key={p.slug}
              to={`/services/${p.slug}`}
              tone="white"
              radius="card"
              data-testid={`service-card-${i}`}
              className="group relative flex flex-col p-8 lg:p-10 transition-colors"
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = C.surfacePrimary)}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = C.brassLine)}
            >
              <span className="font-cormorant tabular-nums mb-5" style={{ color: C.accentMetal, fontSize: "1.6rem", lineHeight: 1 }}>
                {p.n}
              </span>

              <h3
                className="font-cormorant"
                style={{
                  color: C.textOnLight,
                  fontSize: "clamp(1.45rem, 2vw, 1.8rem)",
                  fontWeight: 400,
                  lineHeight: 1.15,
                  letterSpacing: "-0.008em",
                }}
              >
                {p.label}
              </h3>

              <p className="mt-4 font-inter leading-[1.65]" style={{ color: C.inkOnLight, fontSize: "0.98rem" }}>
                {p.outcome}
              </p>

              <FocusAreas6 items={p.focusAreas} className="mt-7 grow" testId={`service-focus-${i}`} />

              <TextLink6 as="span" className="mt-7" testId={`service-explore-${i}`}>
                Explore {p.label}
              </TextLink6>
            </Box6>
          ))}
        </div>
      </div>
    </section>
  );
}
